/**
 * Created by idea on 03/07/2017.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AdminHeaderComponent } from './admin-header.component';
import { HelperModule } from '../../common/helper/helper.module';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [AdminHeaderComponent],
    imports: [CommonModule, RouterModule, HelperModule, FormsModule, ModalModule, TranslateModule.forChild()],
    exports: [AdminHeaderComponent],
})

export class HeaderModule { }



// WEBPACK FOOTER //
// /app/src/app/layout/header/header.module.ts